// extracted by mini-css-extract-plugin
export default {"root":"styles_root__rizjQ","leftPanel":"styles_leftPanel__g2Car","container":"styles_container__1WSOX"};